// ============================================
// THEME SWITCH WITH CUSTOMER METAFIELD SUPPORT
// ============================================


document.addEventListener('DOMContentLoaded', function () {
  const switches = Array.from(document.querySelectorAll('.theme-switch'));
  if (!switches.length) return;

  const getLabel = (el) => el.querySelector('.theme-toggle-label');
  const setUIAll = (isDark) => {
    switches.forEach(sw => {
      const label = getLabel(sw);
      if (label) label.classList.toggle('active', isDark);
      sw.setAttribute('aria-pressed', isDark ? 'true' : 'false');
    });
  };

  const enableDarkMode = () => {
    document.documentElement.classList.add('dark');
    setUIAll(true);
    sessionStorage.setItem('theme', 'dark');
    console.log("[Theme] Dark mode enabled");
  };

  const disableDarkMode = () => {
    document.documentElement.classList.remove('dark');
    setUIAll(false);
    sessionStorage.setItem('theme', 'light');
    console.log("[Theme] Light mode enabled");
  };

  const toggleTheme = () => {
    if (document.documentElement.classList.contains('dark')) {
      disableDarkMode();
    } else {
      enableDarkMode();
    }
  };

  // --- STEP 1: Customer metafield preference ---
  const customerMode = (window.customerColourMode || "").trim();
  console.log("[Theme Pref] Customer preferred appearance:", customerMode);

  if (customerMode === "Dark Mode") {
    enableDarkMode();
  } else if (customerMode === "Light Mode") {
    disableDarkMode();
  } else {
    // Automatic or blank → fall back to session or system
    const savedTheme = sessionStorage.getItem('theme');
    if (savedTheme === 'dark') {
      enableDarkMode();
    } else if (savedTheme === 'light') {
      disableDarkMode();
    } else {
      // Optional: system-based preference
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        enableDarkMode();
      } else {
        disableDarkMode();
      }
    }
  }

  // --- STEP 2: Wire up UI buttons ---
  switches.forEach(sw => {
    if (!sw.hasAttribute('aria-pressed')) sw.setAttribute('aria-pressed', 'false');
    if (!sw.hasAttribute('tabindex')) sw.setAttribute('tabindex', '0');
    if (!sw.hasAttribute('role')) sw.setAttribute('role', 'button');

    sw.addEventListener('click', toggleTheme);
    sw.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleTheme();
      }
    });
  });
});

// Menu Functionality
document.addEventListener('DOMContentLoaded', function () {
  const menuTriggers = document.querySelectorAll('.menu-trigger');
  const searchTriggers = document.querySelectorAll('.search-trigger');
  const searchModals = document.querySelectorAll('.search-modal-trigger');
  const searchWrapper = document.querySelector('.search-wrapper');
  const searchClose = document.querySelector('.search .close__button');

const isHandheld =
  (navigator.maxTouchPoints && navigator.maxTouchPoints > 1) ||
  window.matchMedia('(pointer: coarse)').matches ||
  /Mobi|Android|iP(ad|hone|od)/i.test(navigator.userAgent);

  // -------------------------
  // Menu toggle
  // -------------------------
  if (menuTriggers.length > 0) {
    menuTriggers.forEach(trigger => {
      trigger.addEventListener('click', function () {
        document.querySelector('.main-nav-actions')?.classList.toggle('active');
        document.querySelector('.header-group')?.classList.toggle('active');
        document.querySelector('.main-wrapper')?.classList.toggle('active');
      });
    });
  }

  // -------------------------
  // Desktop search trigger
  // -------------------------
  if (searchTriggers.length > 0) {
    searchTriggers.forEach(trigger => {
      trigger.addEventListener('click', function () {
        console.log('[click] .search-trigger');
        document.querySelector('.main-nav-actions')?.classList.toggle('active');
        document.querySelector('.header-group')?.classList.toggle('active');
        document.querySelector('.main-wrapper')?.classList.toggle('active');

        const searchInputHeader = document.querySelector('.header-group .search-input');
        if (searchInputHeader) {
          searchInputHeader.classList.toggle('active');
        }

        if (searchWrapper) {
          const willActivate = !searchWrapper.classList.contains('active');
          searchWrapper.classList.toggle('active');
          document.body.classList.toggle('search-active');
          const searchInput = document.querySelector('input.search__input');
          if (willActivate && searchInput) {
            setTimeout(() => {
              console.log('[search-trigger] focusing input');
              searchInput.focus();
            }, 50);
          }
        } else {
          //console.warn('[search-trigger] no .search-wrapper found');
        }
      });
    });
  }

  // -------------------------
  // Close button
  // -------------------------
  if (searchClose) {
    searchClose.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector('.main-nav-actions')?.classList.remove('active');
      document.querySelector('.header-group .search-input')?.classList.remove('active');
      (document.querySelector('.search-wrapper') || searchWrapper)?.classList.remove('active');
      document.body.classList.remove('search-active');
    });
  }

  // -------------------------
  // Search modals (desktop + mobile)
  // -------------------------
  if (searchModals.length > 0) {
    searchModals.forEach((btn) => {
      btn.addEventListener('click', function (e) {
        const wrapper = document.querySelector('.search-wrapper');
        const searchInput = document.querySelector('input.search__input');

        if (!wrapper || !searchInput) {
          //console.warn('[search-modal] missing wrapper/input');
          return;
        }

        const willActivate = !wrapper.classList.contains('active');
        wrapper.classList.toggle('active');
        document.body.classList.toggle('search-active');

        if (willActivate) {
          console.log('[search-modal] activating search');

          // ✅ Mobile / tablet: trigger keyboard immediately
          if (isHandheld) {
            try {
              searchInput.focus();
              searchInput.setSelectionRange(
                searchInput.value.length,
                searchInput.value.length
              );
              console.log('[mobile] synchronous focus for keyboard');
            } catch (err) {
             // console.warn('[mobile] focus error', err);
            }
          }

          // ✅ fallback (desktop or animation delay)
          requestAnimationFrame(() => {
            setTimeout(() => {
              if (searchInput.offsetParent !== null) {
                searchInput.focus();
                console.log('[focus] ensured cursor visible');
              }
            }, 30);
          });
        }
      });
    });
  } else {
    console.warn('[init] no .search-modal-trigger found');
  }

  // -------------------------
  // Click outside to close
  // -------------------------
  document.addEventListener('click', function (event) {
    if (!searchWrapper) return;
    if (!searchWrapper.classList.contains('active')) return;

    const clickedInside = searchWrapper.contains(event.target);
    const clickedTrigger = event.target.closest('.search-modal-trigger, .search-trigger');

    if (!clickedInside && !clickedTrigger) {
      searchWrapper.classList.remove('active');
      document.body.classList.remove('search-active');
    }
  });

  // -------------------------
  // Handheld keyboard boost
  // (specific for mobile-search-trigger > .search-modal-trigger)
  // -------------------------
  const mobileTrigger = document.querySelector('.mobile-search-trigger .search-modal-trigger');
  const searchInput = document.querySelector('input.search__input');

  if (mobileTrigger && isHandheld && searchInput) {
    mobileTrigger.addEventListener('click', (e) => {
      console.log('[mobile-search] tapped');
      // Force keyboard open if mobile search tapped
      if (!document.body.classList.contains('search-active')) {
        searchInput.focus();
        searchInput.setSelectionRange(searchInput.value.length, searchInput.value.length);
        console.log('[mobile-search] keyboard triggered on handheld');
      }
    });
  }
});


// Mobile Menu Functionality 
document.addEventListener('DOMContentLoaded', function () {
  const mobileTriggers = document.querySelectorAll('.mobile-trigger');
  if (mobileTriggers.length > 0) {
    mobileTriggers.forEach(trigger => {
      trigger.addEventListener('click', function () {
        document.querySelector('.mobile-menu').classList.toggle('active');
      });
    });
  }
});


(function () {
  function updateSearchSummary(value, els) {
    const hasValue = value.length > 0;
    els.searchTypeSpan.textContent = hasValue ? value : '';
    els.searchSummary?.classList.toggle('active', hasValue);
  }

  function resetPredictiveUI(els) {
    if (els.searchInput) els.searchInput.value = '';
    updateSearchSummary('', els);

    // Optional: clear predictive results if you have a container
    const predictive = document.querySelector('.predictive-results, .search-results');
    if (predictive) predictive.innerHTML = '';

    // Optional: remove any active/loading classes you use
    document.body.classList.remove('search-has-query', 'search-loading');
  }

  function bindSearchLiveTyping() {
    const els = {
      searchInput: document.querySelector('input.search__input'),
      searchTypeSpan: document.querySelector('.search-summary .search-type'),
      searchSummary: document.querySelector('.search-summary'),
      searchForm: document.querySelector('.search-form, form.search, form[role="search"]'),
      resetBtn: document.querySelector('.search_reset')
    };

    if (!els.searchInput || !els.searchTypeSpan) return;

    // Live typing -> update summary text + active state
    els.searchInput.addEventListener('input', function () {
      const value = this.value.trim();
      updateSearchSummary(value, els);
      document.body.classList.toggle('search-has-query', value.length > 0);
    }, { once: false });

    // Click on reset button with class .search_reset
    if (els.resetBtn) {
      els.resetBtn.addEventListener('click', function (e) {
        e.preventDefault(); // keep it manual + predictable
        resetPredictiveUI(els);
        // Re-focus the input if you want
        els.searchInput.focus();
      }, { once: false });
    }

    // Also respond to native form reset (if using <button type="reset">)
    if (els.searchForm) {
      els.searchForm.addEventListener('reset', function () {
        // Allow the form to clear the field, then sync UI
        setTimeout(() => resetPredictiveUI(els), 0);
      }, { once: false });
    }
  }

  document.addEventListener('DOMContentLoaded', bindSearchLiveTyping);
  setTimeout(bindSearchLiveTyping, 500);
  setTimeout(bindSearchLiveTyping, 1000);
})();



// Child & Grandhcild Menus
(function () {
  function getTrigger(event) {
    return event.target.closest('.child-menu, .child-menu > a');
  }

  function toggleSubmenu(li) {
    const subMenu = li.querySelector('.child-sub-menu');
    if (!subMenu) return;
    const isActive = subMenu.classList.toggle('active');
    li.classList.toggle('is-open', isActive);
    const link = li.querySelector('.child-menu > a');
    if (link) {
      link.setAttribute('aria-expanded', String(isActive));
    }
  }

  // Click handling (event delegation)
  document.addEventListener('click', function (e) {
    const trigger = getTrigger(e);
    if (!trigger) return;
    const li = trigger.closest('li');
    if (!li) return;
    const subMenu = li.querySelector('.child-sub-menu');
    if (!subMenu) return; 
    if (e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    toggleSubmenu(li);
  });

document.addEventListener('keydown', function (e) {
    if (!(e.key === 'Enter' || e.key === ' ')) return;

    const activeEl = document.activeElement;
    const link = activeEl && activeEl.matches?.('.child-menu > a') ? activeEl : null;
    if (!link) return;
    const li = link.closest('li');
    const subMenu = li && li.querySelector('.child-sub-menu');
    if (!subMenu) return;
    e.preventDefault();
    toggleSubmenu(li);
  });

  // Initialize aria-expanded on load for any pre-opened submenus
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.child-menu-item').forEach(li => {
      const sub = li.querySelector('.child-sub-menu');
      const link = li.querySelector('.child-menu > a');
      if (sub && link) {
        link.setAttribute('aria-expanded', sub.classList.contains('active') ? 'true' : 'false');
      }
    });
  });
})();

(function(){
  var KEY = 'headerGenderMenuHandle';

  function activateHandle(handle) {
    document.querySelectorAll('.gender-toggle').forEach(function(btn){
      var isActive = btn.getAttribute('data-menu-handle') === handle;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    document.querySelectorAll('.mega-group').forEach(function(group){
      var match = group.getAttribute('data-menu-handle') === handle;
      group.classList.toggle('is-active', match);
      if (match) group.removeAttribute('hidden');
      else group.setAttribute('hidden', 'hidden');
    });

    try { localStorage.setItem(KEY, handle); } catch(e) {}
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('.gender-toggle');
    if (!btn) return;
    var handle = btn.getAttribute('data-menu-handle');
    if (!handle) return;
    e.preventDefault();
    activateHandle(handle);
  });

  document.addEventListener('DOMContentLoaded', function(){
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch(e) {}

    if (saved && document.querySelector('.mega-group[data-menu-handle="'+saved+'"]')) {
      activateHandle(saved);
      return;
    }

    // --- Pull from global variable set by Liquid
   var pref = (window.customerShoppingPreference || "").trim();
  console.log("[Menu Pref]", pref);
    switch (pref) {
      case "Menswear":
        activateHandle('mens-menu');
        break;
      case "Womenswear":
        activateHandle('womens-menu');
        break;
      case "Unisex":
        activateHandle('main-menu');
        break;
      default:
        activateHandle('main-menu');
        break;
    }
  });
})();


// Preserve Open Accordions 
   function toggleAccordionState(key) {
    let openAccordions = JSON.parse(localStorage.getItem('openAccordions') || '[]');
    if (openAccordions.includes(key)) {
      openAccordions = openAccordions.filter(k => k !== key);
    } else {
      openAccordions.push(key);
    }
    localStorage.setItem('openAccordions', JSON.stringify(openAccordions));
  }

  document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.getElementById('filter-accordion-wrapper');
    const openAccordions = JSON.parse(localStorage.getItem('openAccordions') || '[]');

    document.querySelectorAll('[data-accordion]').forEach(panel => {
      const key = panel.getAttribute('data-accordion');
      if (openAccordions.includes(key)) {
        panel.classList.add('open');
      }
    });

    // Once panels are toggled, reveal them
    if (wrapper) {
      wrapper.setAttribute('data-loaded', 'true');
    }
  });

// Accordion Global 
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.accordion-heading').forEach(heading => {
    heading.setAttribute('role', 'button');
    heading.setAttribute('tabindex', '0');
    heading.setAttribute('aria-expanded', 'false');
    const toggle = () => {
      const parent = heading.closest('.accordion');
      if (!parent) return;
      const isActive = parent.classList.toggle('active');
      heading.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    };
    heading.addEventListener('click', toggle);
    heading.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
  });
});

// --- Mobile Filtering ---
document.addEventListener('DOMContentLoaded', () => {
  const facetWrapper = document.querySelector('.mobile-facets__wrapper');
  const mobileFacets = document.querySelector('.mobile-facets');
  const buttonLabel = facetWrapper?.querySelector('.mobile-facets__open-label.button-label');

  if (!facetWrapper || !mobileFacets || !buttonLabel) return;

  const inactiveText = buttonLabel.querySelector('.inactive-state');
  const activeText = buttonLabel.querySelector('.active-state');

  // --- Toggle Drawer ---
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.mobile-facets__wrapper');
    const hideBtn = e.target.closest('.mobile-facets-hide');

    // Close button
    if (hideBtn) {
      mobileFacets.classList.remove('active');
      document.body.classList.remove('overflow-hidden-mobile');
      inactiveText?.classList.add('active');
      activeText?.classList.remove('active');
      return;
    }

    // Drawer toggle
    if (trigger) {
      mobileFacets.classList.toggle('active');
      const isActive = mobileFacets.classList.contains('active');

      inactiveText?.classList.toggle('active', !isActive);
      activeText?.classList.toggle('active', isActive);
      document.body.classList.toggle('overflow-hidden-mobile', isActive);
    }
  });

  // --- Accordion toggle ---
  document.addEventListener('click', (e) => {
    const summary = e.target.closest('summary.mobile-facets__summary');
    if (!summary) return;
    const submenu = summary.closest('details')?.querySelector('.mobile-facets__submenu');
    submenu?.classList.toggle('active');
  });

  // --- Highlight checked filters ---
  const updateFilterChecked = () => {
    document.querySelectorAll('.mobile-facets__item').forEach((li) => {
      const input = li.querySelector('input[type="checkbox"]');
      if (!input) return;
      li.classList.toggle('filter-checked', input.checked);
    });
  };

  updateFilterChecked();
  document.addEventListener('change', (e) => {
    if (e.target.matches('.mobile-facets__checkbox')) updateFilterChecked();
  });
});


// Collection View
document.addEventListener('DOMContentLoaded', function () {
  const gridContainer = document.querySelector('.product-grid-container');
  const viewButtons   = document.querySelectorAll('.collection-views > div');
  const htmlEl        = document.documentElement;

  if (!gridContainer || viewButtons.length === 0) return;

  const views = ['grid-view', 'editorial-view', 'micro-view'];

  // Helper: apply a view cleanly everywhere
  function applyView(view) {
    // Strip any previous view classes
    views.forEach(v => {
      htmlEl.classList.remove(v);
      gridContainer.classList.remove(v);
    });

    // Apply current view
    htmlEl.classList.add(view);
    gridContainer.classList.add(view);

    // Reset active states then activate the matching button
    viewButtons.forEach(btn => btn.classList.remove('active'));
    const match = Array.from(viewButtons).find(btn => btn.classList.contains(view));
    if (match) match.classList.add('active');
  }

  // Determine initial view: saved or default to grid-view
  const saved = sessionStorage.getItem('selectedView');
  const initialView = views.includes(saved) ? saved : 'grid-view';

  // If nothing saved, set the default into storage (optional but keeps things tidy)
  if (!saved) sessionStorage.setItem('selectedView', initialView);

  // Apply initial state
  applyView(initialView);

  // Wire up clicks
  viewButtons.forEach(button => {
    button.addEventListener('click', function () {
      const selectedView = views.find(view => this.classList.contains(view));
      if (!selectedView) return;

      sessionStorage.setItem('selectedView', selectedView);
      applyView(selectedView);
    });
  });
});

// Sizing Chart 
(function () {
  const getPanel = () => document.querySelector('.sizing-chart');
  function openPanel()  { getPanel()?.classList.add('active'); }
  function closePanel() { getPanel()?.classList.remove('active'); }
  function togglePanel(){ getPanel()?.classList.toggle('active'); }
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.size-trigger');
    if (trigger) { e.preventDefault(); togglePanel(); return; }
    const closeBtn = e.target.closest('.sizing-close');
    if (closeBtn) { e.preventDefault(); closePanel(); return; }
    const panel = getPanel();
    if (panel && panel.classList.contains('active')) {
      if (!e.target.closest('.sizing-chart')) {
        closePanel();
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePanel();
  });
})();




// Brand Switch 
  document.addEventListener('DOMContentLoaded', function () {
    const brandSwitch = document.querySelector('.brand-switch');
    const globe = brandSwitch?.querySelector('.brand-map');
    const list = brandSwitch?.querySelector('.brand-list');
    const enableMapMode = () => {
      document.documentElement.classList.add('map');
      brandSwitch?.classList.add('active');
      globe?.classList.add('active');
      list?.classList.remove('active');
      sessionStorage.setItem('brand', 'map');
    };
    const disableMapMode = () => {
      document.documentElement.classList.remove('map');
      brandSwitch?.classList.remove('active');
      globe?.classList.remove('active');
      list?.classList.add('active');
      sessionStorage.setItem('brand', 'list');
    };
    // Load saved theme
    const savedMap = sessionStorage.getItem('brand');
    if (savedMap === 'list') {
      enableMapMode();
    }
    const toggleMap = () => {
      if (document.documentElement.classList.contains('map')) {
        disableMapMode();
      } else {
        enableMapMode();
      }
    };
    brandSwitch?.addEventListener('click', toggleMap);
    brandSwitch?.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleMap();
      }
    });
  });

document.addEventListener('DOMContentLoaded', () => {
  const toggleBtn = document.querySelector('.brands-glossary .global-map');
  const mapView   = document.querySelector('.brands-glossary [data-map="map"]');
  if (!toggleBtn || !mapView) return;

  toggleBtn.addEventListener('click', () => {
    mapView.classList.toggle('active');
    requestAnimationFrame(() => map.resize());
  });
});
let currentPage = 1;

function buildNextPageURL(page) {
  const url = new URL(window.location.href);
  url.searchParams.set('page', page);
  return url.pathname + '?' + url.searchParams.toString();
}

document.addEventListener('DOMContentLoaded', function () {
  if (document.body.dataset.pagination !== 'infinite') return;

  const productGrid = document.getElementById('product-grid');
  const footerEl =
    document.querySelector('footer.site-footer') ||
    document.querySelector('footer.footer') ||
    document.querySelector('footer');

  const sectionId = productGrid?.dataset.id;
  if (!productGrid || !footerEl || !sectionId) return;

  let loading = false;

  function hidePagination() {
    document
      .querySelectorAll('.pagination, .pagination-content, .pagination-wrapper nav')
      .forEach(el => el.remove());
  }

  function loadNextPage() {
    if (loading) return;

    loading = true;
    currentPage += 1;

    const nextURL = buildNextPageURL(currentPage);
    const fullUrl = `${nextURL}&section_id=${sectionId}`;

    console.log('[infinite] loading page', currentPage);

    fetch(fullUrl)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll('#product-grid > li');

        console.log('[infinite] items returned:', newItems.length);

        if (!newItems.length) {
          observer.disconnect();
          console.log('[infinite] end of results');
          return;
        }

        newItems.forEach(item => productGrid.appendChild(item));
      })
      .catch(err => console.error('[infinite] load failed:', err))
      .finally(() => {
        loading = false;
      });
  }

  const observer = new IntersectionObserver(entries => {
    if (!entries[0].isIntersecting) return;
    loadNextPage();
  }, {
    rootMargin: '600px'
  });

  observer.observe(footerEl);
  hidePagination();

  // Reset on filters
  window.addEventListener('filters:updated', () => {
    console.log('[infinite] reset after filters');

    observer.disconnect();
    loading = false;
    currentPage = 1;

    requestAnimationFrame(() => {
      observer.observe(footerEl);
    });
  });
});




// wishlist functionality
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wishlist-button').forEach(button => {
    button.addEventListener('click', async () => {
      const variantId = button.dataset.variantId;
      const handle = button.dataset.productHandle;
      const customerId = window.customerId;
      const shop = window.shopDomain;

      if (!customerId || !shop || !variantId || !handle) {
        console.error('❌ Missing required fields', { customerId, shop, variantId, handle });
        return;
      }

      const isActive = button.classList.contains('active');
      const action = isActive ? 'remove' : 'add';

      try {
        const res = await fetch('https://wishlist-api-azure.vercel.app/api/wishlist-save', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Customer-ID': customerId,
            'X-Shopify-Shop-Domain': shop
          },
         body: JSON.stringify({ productId: variantId, handle, action })
        });

        const json = await res.json();

        if (json.success) {
          button.classList.toggle('active');
          console.log(`✅ Wishlist ${action} success for product ${variantId}`);
        } else {
          console.error('❌ API Error:', json);
        }

      } catch (err) {
        console.error('❌ Network error:', err);
      }
    });
  });
});

// Replace Wishlist Variant ID
document.addEventListener("DOMContentLoaded", () => {
  const wlBtn = document.querySelector(".product-wltrigger");
  if (!wlBtn) {
    console.warn("❌ No .product-wltrigger found");
    return;
  }
  const variantInput = document.querySelector("input.product-variant-id");
  if (!variantInput) {
    console.warn("❌ No .product-variant-id hidden input found");
    return;
  }
  wlBtn.dataset.variantId = variantInput.value;
  console.log("🔥 WL Btn initial variant →", variantInput.value);
  const obs = new MutationObserver(() => {
    wlBtn.dataset.variantId = variantInput.value;
    console.log("🔥 WL Btn updated →", variantInput.value);
  });
  obs.observe(variantInput, { attributes: true, attributeFilter: ["value"] });
  console.log("👀 Tracker running: watching <input.product-variant-id>");
});



// Wishlist → Cart: remove from wishlist FIRST → add to cart → update drawer, footer/CTAs, bubble, empty-state
document.addEventListener('DOMContentLoaded', () => {
  // ---- helpers ----
  async function refreshSection(sectionId, selector = '.shopify-section') {
    const base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    const url  = `${base}?section_id=${encodeURIComponent(sectionId)}`;
    const html = await fetch(url, { credentials: 'same-origin', cache: 'no-store' }).then(r => r.text());
    const doc  = new DOMParser().parseFromString(html, 'text/html');
    const src  = doc.querySelector(selector);
    const dst  = document.getElementById(sectionId);
    if (src && dst) dst.replaceWith(src);
  }

  async function patchDrawerFromSectionHTML() {
    const base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    const url  = `${base}?section_id=cart-drawer`;
    const html = await fetch(url, { credentials: 'same-origin', cache: 'no-store' }).then(r => r.text());
    const doc  = new DOMParser().parseFromString(html, 'text/html');
    const hasItemsNow = !!doc.querySelector('tbody tr.cart-item');
    const dstForm      = document.querySelector('#CartDrawer-Form');
    const srcItemsWrap = doc.querySelector('#CartDrawer-Form .js-contents') || doc.querySelector('cart-drawer-items .js-contents');
    const dstItemsWrap = dstForm?.querySelector('.js-contents');
    if (dstForm && srcItemsWrap && dstItemsWrap) {
      dstItemsWrap.innerHTML = srcItemsWrap.innerHTML;
    } else {
      const srcItems = doc.querySelector('cart-drawer-items');
      const dstItems = document.querySelector('cart-drawer-items');
      if (srcItems && dstItems) {
        dstItems.replaceWith(srcItems);
      } else {
        const serverDrawer = doc.querySelector('cart-drawer');
        if (serverDrawer) document.body.appendChild(serverDrawer);
      }
    }

    // Header (replace if present)
    const srcHeader = doc.querySelector('.drawer__header');
    const dstHeader = document.querySelector('.drawer__header');
    if (srcHeader && dstHeader) dstHeader.replaceWith(srcHeader);

    // Footer & CTAs: replace, insert, or remove as needed
    const srcFooter     = doc.querySelector('.cart-drawer__footer');
    const dstFooter     = document.querySelector('.cart-drawer__footer');
    const dstFooterWrap = document.querySelector('.drawer__footer');
    const srcCtas = doc.querySelector('.cart__ctas');
    const dstCtas = document.querySelector('.cart__ctas');

    // Footer sync
    if (srcFooter) {
      if (dstFooter) {
        dstFooter.replaceWith(srcFooter);
      } else if (dstFooterWrap) {
        const before = dstFooterWrap.querySelector('.cart__ctas') || null;
        dstFooterWrap.insertBefore(srcFooter, before);
      }
    } else if (dstFooter) {
      dstFooter.remove();
    }

    // CTAs sync
    if (srcCtas) {
      if (dstCtas) {
        dstCtas.replaceWith(srcCtas);
      } else if (dstFooterWrap) {
        dstFooterWrap.appendChild(srcCtas);
      }
    } else if (dstCtas) {
      dstCtas.remove();
    }

    // Empty state (ensure correct presence/absence)
    const srcEmpty = doc.querySelector('.drawer__inner-empty');
    const dstEmpty = document.querySelector('.drawer__inner-empty');
    if (srcEmpty && !dstEmpty) {
      const parent = document.querySelector('#CartDrawer .drawer__inner') || document.querySelector('cart-drawer .drawer__inner');
      if (parent) parent.appendChild(srcEmpty);
    } else if (!srcEmpty && dstEmpty) {
      dstEmpty.remove();
    } else if (srcEmpty && dstEmpty) {
      dstEmpty.replaceWith(srcEmpty);
    }

    // is-empty flags
    const drawerEl = document.querySelector('cart-drawer');
    const itemsEl  = document.querySelector('cart-drawer-items');
    [drawerEl, itemsEl].forEach(el => el && el.classList.toggle('is-empty', !hasItemsNow));

    // Theme hooks
    if (typeof window.applyInventoryGuards === 'function') window.applyInventoryGuards(document);
    if (typeof window.reInitCartSwiper === 'function') window.reInitCartSwiper();
    if (typeof window.guardDrawerQuickAddButtons === 'function') window.guardDrawerQuickAddButtons();
  }

  // ---- main handler ----
  document.querySelectorAll('.wishlist-addtocart').forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      if (btn.dataset.processing === '1') return;
      btn.dataset.processing = '1';

      const form = btn.closest('form');
      if (!form) { btn.dataset.processing = ''; return; }

      const fd = new FormData(form);
      const variantId = fd.get('id') || form.querySelector('input[name="id"]')?.value;
      const qty = Number(fd.get('quantity') || 1) || 1;
      if (!variantId) { btn.dataset.processing = ''; return; }

      const productId = btn.dataset.productId;
      const handle    = btn.dataset.productHandle;

      const labelEl = btn.querySelector('span');
      const spinner = btn.querySelector('.loading__spinner');
      const prev = labelEl ? labelEl.textContent : '';
      btn.disabled = true;
      if (labelEl) labelEl.textContent = 'Moving...';
      spinner?.classList.remove('hidden');

      try {
        // 1) Remove from wishlist metafield first
        if (!(window.customerId && window.shopDomain && productId && handle)) throw 0;
        const wlOk = await fetch('https://wishlist-api-azure.vercel.app/api/wishlist-save', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Customer-ID': window.customerId,
            'X-Shopify-Shop-Domain': window.shopDomain
          },
          body: JSON.stringify({ productId: variantId, handle, action: 'remove' }),
          credentials: 'same-origin'
        }).then(r => r.ok ? r.json() : null).then(j => !!j?.success);
        if (!wlOk) throw 0;

        // 2) Add to cart
        const add = new FormData();
        add.append('id', variantId);
        add.append('quantity', qty);
        const added = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: add,
          credentials: 'same-origin',
          cache: 'no-store'
        }).then(r => r.ok);
        if (!added) throw 0;
        await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).catch(() => {});
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wishlist' });
        }
        if (typeof window.refreshDrawer === 'function') {
          await window.refreshDrawer();
        }
        await patchDrawerFromSectionHTML();
        await updateCartCountBubble();
        // If you have a header shipping bar section, also refresh it:
        // await refreshSection('free-shipping-bar').catch(() => {});

        // 5) Open drawer
        document.querySelector('cart-drawer')?.open?.();

        // 6) Remove wishlist tile
        (
          btn.closest('.wishlist-product') ||
          btn.closest('.grid__item') ||
          btn.closest('[data-wishlist-item]') ||
          btn.closest('.wish-card-wrapper')
        )?.remove();
      } finally {
        btn.disabled = false;
        if (labelEl) labelEl.textContent = prev || 'Add to Bag';
        spinner?.classList.add('hidden');
        btn.dataset.processing = '';
      }
    });
  });
});


// Cart → Wishlist: add to wishlist FIRST → remove line (change.js) → hard-sync drawer (items, totals, CTAs), bubble, and empty-state
document.addEventListener('DOMContentLoaded', () => {
  // ---- helpers ----
  function smoothRemove(el) {
    if (!el) return;
    const h = el.getBoundingClientRect().height;
    el.style.boxSizing = 'border-box';
    el.style.height = h + 'px';
    el.style.transition = 'height .25s ease, opacity .25s ease, margin .25s ease, padding .25s ease';
    void el.offsetHeight;
    el.style.opacity = '0';
    el.style.marginTop = '0';
    el.style.marginBottom = '0';
    el.style.paddingTop = '0';
    el.style.paddingBottom = '0';
    el.style.height = '0px';
    setTimeout(() => el.remove(), 260);
  }

  async function refreshSection(sectionId, selector = '.shopify-section') {
    const base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    const url  = `${base}?section_id=${encodeURIComponent(sectionId)}`;
    const html = await fetch(url, { credentials: 'same-origin', cache: 'no-store' }).then(r => r.text());
    const doc  = new DOMParser().parseFromString(html, 'text/html');
    const src  = doc.querySelector(selector);
    const dst  = document.getElementById(sectionId);
    if (src && dst) dst.replaceWith(src);
  }

  async function patchDrawerFromSectionHTML() {
    const base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    const url  = `${base}?section_id=cart-drawer`;
    const html = await fetch(url, { credentials: 'same-origin', cache: 'no-store' }).then(r => r.text());
    const doc  = new DOMParser().parseFromString(html, 'text/html');
    const hasItemsNow = !!doc.querySelector('tbody tr.cart-item');
    const dstForm      = document.querySelector('#CartDrawer-Form');
    const srcItemsWrap = doc.querySelector('#CartDrawer-Form .js-contents') || doc.querySelector('cart-drawer-items .js-contents');
    const dstItemsWrap = dstForm?.querySelector('.js-contents');

    if (dstForm && srcItemsWrap && dstItemsWrap) {
      dstItemsWrap.innerHTML = srcItemsWrap.innerHTML;
    } else {
      const srcItems = doc.querySelector('cart-drawer-items');
      const dstItems = document.querySelector('cart-drawer-items');
      if (srcItems && dstItems) {
        dstItems.replaceWith(srcItems);
      } else {
        const serverDrawer = doc.querySelector('cart-drawer');
        if (serverDrawer) document.body.appendChild(serverDrawer);
      }
    }

    // Header
    const srcHeader = doc.querySelector('.drawer__header');
    const dstHeader = document.querySelector('.drawer__header');
    if (srcHeader && dstHeader) dstHeader.replaceWith(srcHeader);
    const srcFooter     = doc.querySelector('.cart-drawer__footer');
    const dstFooter     = document.querySelector('.cart-drawer__footer');
    const dstFooterWrap = document.querySelector('#CartDrawer .drawer__footer')
                        || document.querySelector('cart-drawer .drawer__footer')
                        || document.querySelector('.drawer__footer');

    if (srcFooter) {
      if (dstFooter) {
        dstFooter.replaceWith(srcFooter);
      } else if (dstFooterWrap) {
        const before = dstFooterWrap.querySelector('.cart__ctas') || null;
        dstFooterWrap.insertBefore(srcFooter, before);
      }
    } else if (dstFooter) {
      dstFooter.remove();
    }

    const srcCtas =
         doc.querySelector('#CartDrawer-Form .cart__ctas')
      || doc.querySelector('.drawer__footer .cart__ctas')
      || doc.querySelector('.cart__ctas');
    const dstCtas =
         document.querySelector('#CartDrawer-Form .cart__ctas')
      || document.querySelector('.drawer__footer .cart__ctas')
      || document.querySelector('.cart__ctas');

    if (srcCtas) {
      if (dstCtas) {
        dstCtas.innerHTML = srcCtas.innerHTML; // updates price text reliably
      } else if (dstFooterWrap) {
        const freshFooter = document.querySelector('.cart-drawer__footer');
        if (freshFooter && freshFooter.parentElement === dstFooterWrap) {
          freshFooter.insertAdjacentElement('afterend', srcCtas);
        } else {
          dstFooterWrap.appendChild(srcCtas);
        }
      } else {
        const formEl = document.getElementById('CartDrawer-Form');
        if (formEl) formEl.appendChild(srcCtas);
      }
    } else if (dstCtas) {
      dstCtas.remove();
    }

    // Empty state
    const srcEmpty = doc.querySelector('.drawer__inner-empty');
    const dstEmpty = document.querySelector('.drawer__inner-empty');
    if (srcEmpty && !dstEmpty) {
      const parent = document.querySelector('#CartDrawer .drawer__inner') || document.querySelector('cart-drawer .drawer__inner');
      if (parent) parent.appendChild(srcEmpty);
    } else if (!srcEmpty && dstEmpty) {
      dstEmpty.remove();
    } else if (srcEmpty && dstEmpty) {
      dstEmpty.replaceWith(srcEmpty);
    }

    // is-empty flags
    const drawerEl = document.querySelector('cart-drawer');
    const itemsEl  = document.querySelector('cart-drawer-items');
    [drawerEl, itemsEl].forEach(el => el && el.classList.toggle('is-empty', !hasItemsNow));

    // Theme hooks
    if (typeof window.applyInventoryGuards === 'function') window.applyInventoryGuards(document);
    if (typeof window.reInitCartSwiper === 'function') window.reInitCartSwiper();
    if (typeof window.guardDrawerQuickAddButtons === 'function') window.guardDrawerQuickAddButtons();
  }

  // ---- main (delegated) ----
  document.addEventListener('click', async (e) => {
    
    const btn = e.target.closest('.wish-cart-wrapper .wishlist-button');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.processing === '1') return;
    btn.dataset.processing = '1';

    const wrap      = btn.closest('.wish-cart-wrapper');
    const row       = btn.closest('tr.cart-item');
    const indexStr  = row?.querySelector('input.quantity__input')?.dataset.index;
    const index     = Number(indexStr);
    const variantId = row?.querySelector('input.quantity__input')?.dataset.quantityVariantId || row?.querySelector('.wishlist-button')?.dataset.variantId || null;
    const handle    = btn.dataset.productHandle || wrap?.dataset.productHandle;

    if (!variantId || !handle || !index || !window.customerId || !window.shopDomain) {
      btn.dataset.processing = '';
      return;
    }
    const inactiveTxt  = btn.querySelector('.inactive-text');
    const prevInactive = inactiveTxt ? inactiveTxt.textContent : '';
    btn.style.pointerEvents = 'none';
    if (inactiveTxt) inactiveTxt.textContent = 'Moving…';
    try {
      // 1) Add to wishlist metafield first
      const wlRes = await fetch('https://wishlist-api-azure.vercel.app/api/wishlist-save', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Customer-ID': window.customerId,
          'X-Shopify-Shop-Domain': window.shopDomain
        },
        body: JSON.stringify({ productId: variantId, handle, action: 'add' }),
        credentials: 'same-origin'
      });
      const wlJson = await wlRes.json().catch(() => null);
      if (!(wlRes.ok && wlJson?.success)) throw 0;

      // 2) Remove the cart line by exact LINE index
      const chRes = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: index, quantity: 0 }),
        credentials: 'same-origin'
      });
      if (!chRes.ok) throw 0;

      // Animate the row away immediately
      if (row && document.body.contains(row)) smoothRemove(row);

      // Keep cart state hot for any listeners
      await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).catch(() => {});

      // Prefer native hooks if available
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wishlist' });
      }
      if (typeof window.refreshDrawer === 'function') {
        await window.refreshDrawer();
      }
      await patchDrawerFromSectionHTML();
      await updateCartCountBubble();
      document.querySelector('cart-drawer')?.open?.();
    } catch (_) {
      // silent
    } finally {
      if (document.body.contains(btn)) {
        if (inactiveTxt) inactiveTxt.textContent = prevInactive || 'Move to Wishlist +';
        btn.style.pointerEvents = '';
        btn.dataset.processing = '';
      }
    }
  });
});


document.addEventListener("DOMContentLoaded", () => {

  function smoothRemove(el) {
    if (!el) return;
    const h = el.getBoundingClientRect().height;
    el.style.boxSizing = 'border-box';
    el.style.height = h + 'px';
    el.style.transition = 'height .25s ease, opacity .25s ease, margin .25s ease, padding .25s ease';
    void el.offsetHeight;
    el.style.opacity = '0';
    el.style.marginTop = '0';
    el.style.marginBottom = '0';
    el.style.paddingTop = '0';
    el.style.paddingBottom = '0';
    el.style.height = '0px';
    setTimeout(() => el.remove(), 260);
  }

  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".wishlist-button");
    if (!btn) return;

    e.preventDefault();
    if (btn.dataset.processing === "1") return;
    btn.dataset.processing = "1";

    // ✔ Correct values
    const variantId = btn.dataset.variantId;
    const handle    = btn.dataset.productHandle;

    const card = btn.closest(".wishlist-product");

    if (!variantId || !handle) {
      console.warn("Missing variantId or handle", { variantId, handle });
      btn.dataset.processing = "";
      return;
    }

    try {
      // 1) REMOVE from metafield
      const res = await fetch("https://wishlist-api-azure.vercel.app/api/wishlist-save", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Customer-ID": window.customerId,
          "X-Shopify-Shop-Domain": window.shopDomain
        },
        body: JSON.stringify({
          productId: variantId, // ✔ correct
          handle,
          action: "remove"
        }),
        credentials: "same-origin"
      });

      const json = await res.json().catch(() => null);

      if (!res.ok || !json?.success) throw 0;

      // 2) Remove DOM card nice + smooth
      if (card) smoothRemove(card);

    } catch (err) {
      console.warn("Wishlist remove failed", err);
    } finally {
      btn.dataset.processing = "";
    }
  });

});



// Login & Register Toggle (supports multiple popups/inline containers)
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.login-popup, .login-inline').forEach(container => {
    const toggleButtons = container.querySelectorAll('.form-toggle > div');
    const loginForm = container.querySelector('.login-form');
    const registerForm = container.querySelector('.register-form');
    const closeBtn = container.querySelector('.popup-close');

    // Toggle between Login and Register 
    toggleButtons.forEach(button => {
      button.addEventListener('click', () => {
        toggleButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');

        const label = (button.dataset.target || button.textContent).trim().toLowerCase();
        const isLogin = label === 'login';

        if (loginForm) loginForm.classList.toggle('hidden', !isLogin);
        if (registerForm) registerForm.classList.toggle('hidden', isLogin);
      });
    });

    // Close just this container
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        container.classList.remove('active');
      });
    }
  });

  // Open: default to targeting .login-popup 
  document.querySelectorAll('.login-link').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const targetSel = link.getAttribute('data-target') || '.login-popup';
      document.querySelectorAll(targetSel).forEach(el => el.classList.add('active'));
    });
  });
});


// Swiper Cursor
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.product-hero-gallery ');
  if (!container) return;
  const cursor = container.querySelector('.swiper-cursor');
  if (!cursor) return;
  container.addEventListener('mouseenter', () => {
    cursor.style.opacity = '1';
  });
  container.addEventListener('mouseleave', () => {
    cursor.style.opacity = '0';
  });
  container.addEventListener('mousemove', (e) => {
    const rect = container.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    cursor.style.left = `${x}px`;
    cursor.style.top = `${y}px`;
  });
});

// Product Media Modal
document.addEventListener('DOMContentLoaded', () => {
  const swiper = document.querySelector('.product-hero-swiper');
  const modal = document.querySelector('.product-media-modal');
  const product = document.querySelector('.product-single');

  if (swiper && modal) {
    swiper.addEventListener('click', () => {
      modal.classList.add('active');
      product.classList.add('active');
    });
  }
 document.addEventListener('click', (e) => {
    if (e.target.closest('.popup-close')) {
      const activeModal = document.querySelector('.product-media-modal.active');
      if (activeModal) {
        activeModal.classList.remove('active');
        product.classList.remove('active');
      }
    }
  });
});


// Account Content Toggle
document.addEventListener('DOMContentLoaded', function () {
    const menuLinks = document.querySelectorAll('.account-item[data-item]');
    const contentBlocks = document.querySelectorAll('[data-content]');

    function clearActiveStates() {
      menuLinks.forEach(link => link.classList.remove('current-item'));
      contentBlocks.forEach(block => block.classList.remove('active'));
    }

    menuLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();

        const selected = this.getAttribute('data-item');

        clearActiveStates();
        this.classList.add('current-item');

        const targetBlock = document.querySelector(`[data-content="${selected}"]`);
        if (targetBlock) targetBlock.classList.add('active');
      });
    });

    // Optional: Set default active if none set
    const defaultLink = document.querySelector('.account-item.current-item[data-item]') || menuLinks[0];
    if (defaultLink) {
      defaultLink.classList.add('current-item');
      const defaultTarget = defaultLink.getAttribute('data-item');
      const defaultContent = document.querySelector(`[data-content="${defaultTarget}"]`);
      if (defaultContent) defaultContent.classList.add('active');
    }
  });


// Update Account Name
document.addEventListener('DOMContentLoaded', () => {
  const editBtn = document.getElementById('edit-name');
  const saveBtn = document.getElementById('save-name');
  const firstNameInput = document.getElementById('first-name-input');
  const lastNameInput = document.getElementById('last-name-input');
  const customerId = window.customerId;
  const shop = window.shopDomain;

  if (!editBtn || !saveBtn || !firstNameInput || !lastNameInput || !customerId || !shop) return;

  editBtn.addEventListener('click', () => {
    firstNameInput.removeAttribute('readonly');
    lastNameInput.removeAttribute('readonly');
    firstNameInput.focus();
    editBtn.style.display = 'none';
    saveBtn.style.display = 'inline-block';
  });

  saveBtn.addEventListener('click', async () => {
    const firstName = firstNameInput.value.trim();
    const lastName = lastNameInput.value.trim();

    if (!firstName || !lastName) {
      alert('Please enter both first and last names.');
      return;
    }

    const payload = {
  first_name: firstName,
  last_name: lastName
};

    console.log("🔄 Sending name update:", payload);
    try {
      
      const res = await fetch('https://customer-profile-api.vercel.app/api/update-customer-name', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Customer-ID': customerId,
          'X-Shopify-Shop-Domain': shop
        },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      console.log("✅ Response from name update:", data);

      if (data.success) {
        alert('Name updated successfully.');
        firstNameInput.setAttribute('readonly', true);
        lastNameInput.setAttribute('readonly', true);
        saveBtn.style.display = 'none';
        editBtn.style.display = 'inline-block';
      } else {
        console.error('❌ Save failed:', data);
        alert('Failed to update name.');
      }
    } catch (err) {
      console.error('💥 Request error:', err);
      alert('An error occurred while saving. Check console for details.');
    }
  });
});



/// ============================================
// ACCOUNT PROFILE MANAGEMENT
// Handles: DOB, Shoe, Clothing, Shop Pref, Notifications (edit/save buttons)
// + Preferences Form (appearance, text size, scroll, currency, language)
// ============================================
document.addEventListener("DOMContentLoaded", () => {
  const API_URL = "https://customer-profile-api.vercel.app/api/save-customer-metafield";
  const customerId = window.customerId;
  const shopDomain = window.shopDomain;
  if (!customerId || !shopDomain) {
    console.error("[Profile] Missing customer ID or shop domain", { customerId, shopDomain });
    return;
  }

  // ---------- Helpers ----------
function getMetaType(key) {
  const listFields = [
    "preferred_shoe_size",
    "preferred_womans_shoe_size",
    "preferred_clothing_size",
    "preferred_notification_method",
    "preferred_appearance",
    "preferred_text_size",
    "preferred_scroll_method",
    "preferred_currency",
    "preferred_language"
  ];

  if (listFields.includes(key)) return "list.single_line_text_field";
  if (key === "date_of_birth") return "date"; // 🩵 Added fix
  return "single_line_text_field";
}

function getMetaValue(key, value) {
  const listFields = [
    "preferred_shoe_size",
    "preferred_womans_shoe_size",
    "preferred_clothing_size",
    "preferred_notification_method",
    "preferred_appearance",
    "preferred_text_size",
    "preferred_scroll_method",
    "preferred_currency",
    "preferred_language"
  ];

  if (listFields.includes(key)) {
    const arr = Array.isArray(value)
      ? value
      : typeof value === "string"
      ? value.split(",").map(v => v.trim()).filter(Boolean)
      : [];
    console.log(`[MetaFormat] '${key}' formatted for list:`, arr);
    return JSON.stringify(arr); // ✅ Important — stringified array for Shopify
  }
  return value;
}


  // =====================================================
  // SECTION 1: FIELD UPDATE HANDLERS
  // =====================================================
  const fields = [
    { key: "date_of_birth", inputId: "dob-input", editBtnId: "edit-dob", saveBtnId: "save-dob", type: "date" },
    { key: "preferred_shoe_size", inputId: "shoe-select", editBtnId: "edit-shoe", saveBtnId: "save-shoe" },
    { key: "preferred_womans_shoe_size", inputId: "wshoe-select", editBtnId: "edit-wshoe", saveBtnId: "save-wshoe" },
   { key: "preferred_clothing_size", inputId: "clothing-select", editBtnId: "edit-clothing", saveBtnId: "save-clothing" },
    { key: "shopping_preference", inputId: "shop-select", editBtnId: "edit-shop", saveBtnId: "save-shop" },
    { key: "preferred_notification_method", inputId: "notification-select", editBtnId: "edit-notification", saveBtnId: "save-notification" }
  ];

  fields.forEach(({ key, inputId, editBtnId, saveBtnId }) => {
    const input = document.getElementById(inputId);
    const editBtn = document.getElementById(editBtnId);
    const saveBtn = document.getElementById(saveBtnId);
    const hiddenBlock = input?.closest(".profile-field-group")?.querySelector(".profile-hidden");

    if (!input || !editBtn || !saveBtn) {
      //console.warn(`[Profile] Skipping field '${key}' (missing elements)`);
      return;
    }

    // --- Edit button ---
    editBtn.addEventListener("click", () => {
      if (hiddenBlock) hiddenBlock.classList.toggle("hidden");
      if (input.tagName.toLowerCase() === "select") input.disabled = false;
      else input.removeAttribute("readonly");
      input.focus();
      editBtn.style.display = "none";
      saveBtn.style.display = "inline-block";
    });

   // --- Save button ---
  saveBtn.addEventListener("click", async () => {
  let rawValue = input.value?.trim();

  // 🩵 Handle date of birth specially (ensure valid ISO format)
  if (key === "date_of_birth") {
    if (!rawValue || isNaN(Date.parse(rawValue))) {
      // console.warn("[Profile] Invalid date input — skipping save.");
      const notif = document.querySelector("account-notification");
      const titleSpan = notif?.querySelector(".status");
      const messageEl = notif?.querySelector(".notification-status");
      if (notif) {
        notif.classList.remove("active");
        notif.classList.add("error", "active");
        if (titleSpan) titleSpan.textContent = "Invalid Date";
        if (messageEl) messageEl.textContent = "Please select a valid date of birth before saving.";
        setTimeout(() => notif.classList.remove("active", "error"), 5000);
      }
      return; // stop save
    }
    // Standardize date format to YYYY-MM-DD for metafield
    rawValue = new Date(rawValue).toISOString().split("T")[0];
  }
  
  // convert comma-separated strings into arrays for list fields
  const listKeys = [
    "preferred_notification_method",
    "preferred_clothing_size",
    "preferred_shoe_size",
    "preferred_womans_shoe_size"
  ];
  if (listKeys.includes(key)) {
    rawValue = input.value
      .split(",")
      .map(v => v.trim())
      .filter(Boolean);
  }

  const payload = {
    key,
    value: getMetaValue(key, rawValue),
    type: getMetaType(key)
  };

  console.groupCollapsed(`[Profile → Vercel API Request] ${key}`);
  console.log("📦 Key:", key);
  console.log("📦 Raw Value (from input):", rawValue);
  console.log("📦 typeof rawValue:", typeof rawValue, " | Array.isArray:", Array.isArray(rawValue));
  console.log("📦 Meta Type:", getMetaType(key));
  console.log("📦 Meta Value (getMetaValue):", getMetaValue(key, rawValue));
  console.log("📦 Final Payload (object):", payload);
  console.log("📦 Final JSON String (to be sent):", JSON.stringify(payload, null, 2));
  console.log("📦 Headers:", {
    "X-Customer-ID": customerId,
    "X-Shopify-Shop-Domain": shopDomain,
    "Content-Type": "application/json"
  });
  console.groupEnd();

  try {
    const res = await fetch(API_URL, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        "X-Customer-ID": customerId,
        "X-Shopify-Shop-Domain": shopDomain
      },
      body: JSON.stringify(payload)
    });

    const data = await res.json();
    console.log("Response:", data);
    const notif = document.querySelector("account-notification");
    const titleSpan = notif?.querySelector(".status");
    const messageEl = notif?.querySelector(".notification-status");

    if (res.ok && data.success) {
      console.log(`[Profile] '${key}' saved successfully.`);

      // ✅ Replace alert with success message
      if (notif) {
        notif.classList.remove("error");
        notif.classList.add("active");
        if (titleSpan) titleSpan.textContent = "Successful";
        if (messageEl) messageEl.textContent = `Your ${key.replace(/_/g, " ")} has been updated.`;
        setTimeout(() => notif.classList.remove("active"), 5000);
      }

      if (input.tagName.toLowerCase() === "select") input.disabled = true;
      else input.setAttribute("readonly", true);
      if (hiddenBlock) hiddenBlock.classList.add("hidden");
      saveBtn.style.display = "none";
      editBtn.style.display = "inline-block";
    } else {
      console.error(`[Profile] Save failed for '${key}':`, data);

      // ⚠️ Replace alert with failure message
      if (notif) {
        notif.classList.remove("active");
        notif.classList.add("error", "active");
        if (titleSpan) titleSpan.textContent = "Failed";
        if (messageEl) messageEl.textContent = `We couldn’t update your ${key.replace(/_/g, " ")}. Please try again.`;
        setTimeout(() => notif.classList.remove("active", "error"), 5000);
      }
    }
  } catch (err) {
    console.error(`[Profile] Error saving '${key}':`, err);

    // ⚠️ Replace alert with error message
    const notif = document.querySelector("account-notification");
    const titleSpan = notif?.querySelector(".status");
    const messageEl = notif?.querySelector(".notification-status");

    if (notif) {
      notif.classList.remove("active");
      notif.classList.add("error", "active");
      if (titleSpan) titleSpan.textContent = "Error";
      if (messageEl) messageEl.textContent = `A network error occurred while updating ${key.replace(/_/g, " ")}.`;
      setTimeout(() => notif.classList.remove("active", "error"), 5000);
    }
  }

  console.groupEnd();
});



  // =====================================================
  // SECTION 2: Notification Button Toggles
  // =====================================================
  const notifGroups = document.querySelectorAll(".button-group[data-type]");
  const notifInput = document.getElementById("notification-select");

  if (notifGroups.length && notifInput) {
    notifGroups.forEach(group => {
      const yesBtn = group.querySelector(".yes");
      const noBtn = group.querySelector(".no");
      const type = group.dataset.type;

      yesBtn.addEventListener("click", () => {
        yesBtn.classList.add("active");
        noBtn.classList.remove("active");
        updateNotificationValue(type, true);
      });

      noBtn.addEventListener("click", () => {
        noBtn.classList.add("active");
        yesBtn.classList.remove("active");
        updateNotificationValue(type, false);
      });
    });

    function updateNotificationValue(type, enabled) {
      let values = notifInput.value ? notifInput.value.split(",").map(v => v.trim()).filter(Boolean) : [];
      const exists = values.includes(type);
      if (enabled && !exists) values.push(type);
      if (!enabled && exists) values = values.filter(v => v !== type);
      notifInput.value = values.join(", ");
      console.log("[Notifications] Updated Input:", notifInput.value);
    }
  }
});


// --- Clothing Size Grid Logic ---
const clothingEditBtn = document.getElementById("edit-clothing");
const clothingSaveBtn = document.getElementById("save-clothing");
const clothingGrid = document.getElementById("clothing-size-grid");
const clothingInput = document.getElementById("clothing-select");
const clothingHiddenBlock = clothingGrid?.closest(".profile-hidden");

if (clothingEditBtn && clothingSaveBtn && clothingGrid && clothingInput && clothingHiddenBlock) {
  clothingEditBtn.addEventListener("click", () => {
    clothingHiddenBlock.classList.remove("hidden");
    clothingEditBtn.style.display = "none";
    clothingSaveBtn.style.display = "inline-block";
  });

  clothingSaveBtn.addEventListener("click", () => {
    clothingHiddenBlock.classList.add("hidden");
    clothingSaveBtn.style.display = "none";
    clothingEditBtn.style.display = "inline-block";
  });

  clothingGrid.querySelectorAll(".size-toggle").forEach(btn => {
    btn.addEventListener("click", () => {
      btn.classList.toggle("active");
      const selected = Array.from(
        clothingGrid.querySelectorAll(".size-toggle.active")
      ).map(b => b.dataset.size);
      clothingInput.value = selected.join(", ");
      //("[Clothing Size] Selected:", selected);
    });
  });
} else {
  //console.warn("[Clothing Size] Missing one or more elements.");
}



// --- Shoe Size Grid Logic ---
const shoeEditBtn = document.getElementById("edit-shoe");
const shoeSaveBtn = document.getElementById("save-shoe");
const shoeGrid = document.getElementById("shoe-size-grid");
const shoeInput = document.getElementById("shoe-select");
const shoeHiddenBlock = shoeGrid?.closest(".profile-hidden");

if (shoeEditBtn && shoeSaveBtn && shoeGrid && shoeInput && shoeHiddenBlock) {
  shoeEditBtn.addEventListener("click", () => {
    shoeHiddenBlock.classList.remove("hidden");
    shoeEditBtn.style.display = "none";
    shoeSaveBtn.style.display = "inline-block";
  });

  shoeSaveBtn.addEventListener("click", () => {
    shoeHiddenBlock.classList.add("hidden");
    shoeSaveBtn.style.display = "none";
    shoeEditBtn.style.display = "inline-block";
  });

  shoeGrid.querySelectorAll(".size-toggle").forEach(btn => {
    btn.addEventListener("click", () => {
      btn.classList.toggle("active");
      const selected = Array.from(
        shoeGrid.querySelectorAll(".size-toggle.active")
      ).map(b => b.dataset.size);
      shoeInput.value = selected.join(", ");
      //console.log("[Shoe Size] Selected:", selected);
    });
  });
} else {
  //console.warn("[Shoe Size] Missing one or more elements.");
}

// --- Shoe Size Grid Logic ---
const wshoeEditBtn = document.getElementById("edit-wshoe");
const wshoeSaveBtn = document.getElementById("save-wshoe");
const wshoeGrid = document.getElementById("wshoe-size-grid");
const wshoeInput = document.getElementById("wshoe-select");
const wshoeHiddenBlock = wshoeGrid?.closest(".wprofile-hidden");

if (wshoeEditBtn && wshoeSaveBtn && wshoeGrid && wshoeInput && wshoeHiddenBlock) {
  wshoeEditBtn.addEventListener("click", () => {
    wshoeHiddenBlock.classList.remove("hidden");
    wshoeEditBtn.style.display = "none";
    wshoeSaveBtn.style.display = "inline-block";
  });

  wshoeSaveBtn.addEventListener("click", () => {
    wshoeHiddenBlock.classList.add("hidden");
    wshoeSaveBtn.style.display = "none";
    wshoeEditBtn.style.display = "inline-block";
  });

  wshoeGrid.querySelectorAll(".wsize-toggle").forEach(btn => {
    btn.addEventListener("click", () => {
      btn.classList.toggle("active");
      const selected = Array.from(
        wshoeGrid.querySelectorAll(".wsize-toggle.active")
      ).map(b => b.dataset.size);
      wshoeInput.value = selected.join(", ");
      //console.log("[Shoe Size] Selected:", selected);
    });
  });
} else {
  //console.warn("[Shoe Size] Missing one or more elements.");
}


// =====================================================
// SECTION 2: PREFERENCES FORM (grouped fields)
// =====================================================
const form = document.getElementById("preferences-form");
if (!form) {
  //console.warn("[Preferences] Form not found, skipping batch save.");
  return;
}

// --- Toggle active buttons (Appearance/Text Size/Scroll) ---
form.querySelectorAll(".pref-button").forEach(btn => {
  btn.addEventListener("click", () => {
    const group = btn.dataset.group;
    form.querySelectorAll(`.pref-button.${group}`).forEach(b => b.classList.remove("active"));
    btn.classList.add("active");
  });
});

// --- Handle form submission ---
form.addEventListener("submit", async (e) => {
  e.preventDefault();

  const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
  const originalText = submitBtn ? submitBtn.textContent : "";
  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = "Processing...";
  }

  const payload = {
    preferred_appearance: form.querySelector(".appearance.active")?.dataset.value,
    preferred_text_size: form.querySelector(".text-size.active")?.dataset.value,
    preferred_scroll_method: form.querySelector(".scroll.active")?.dataset.value,
    preferred_currency: form.querySelector("#PreferredCurrency")?.value,
    preferred_language: form.querySelector("#PreferredLanguage")?.value
  };

  const cleaned = Object.fromEntries(
    Object.entries(payload).filter(([_, v]) => v && v.trim && v.trim() !== "")
  );

  if (Object.keys(cleaned).length === 0) {
    //console.warn("[Preferences] Nothing to update.");

    const notif = document.querySelector("account-notification");
    const titleSpan = notif?.querySelector(".status");
    const messageEl = notif?.querySelector(".notification-status");
    if (notif) {
      notif.classList.remove("error");
      notif.classList.add("error", "active");
      if (titleSpan) titleSpan.textContent = "No Changes";
      if (messageEl) messageEl.textContent = "No preferences were selected to update.";
      setTimeout(() => notif.classList.remove("active", "error"), 5000);
    }

    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = originalText;
    }
    return;
  }

  let successCount = 0, failCount = 0;

  for (const [key, value] of Object.entries(cleaned)) {
    const body = JSON.stringify({
      key,
      value: getMetaValue(key, value),
      type: getMetaType(key)
    });

    console.group(`[Preferences] Saving '${key}'`);
    console.log("POST →", API_URL, "Body:", body);

    try {
      const res = await fetch(API_URL, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          "X-Customer-ID": customerId,
          "X-Shopify-Shop-Domain": shopDomain
        },
        body
      });

      const data = await res.json();
      console.log("Response:", data);

      if (res.ok && data.success) successCount++;
      else failCount++;
    } catch (err) {
      console.error(`[Preferences] Error saving '${key}':`, err);
      failCount++;
    }

    console.groupEnd();
  }

  const notif = document.querySelector("account-notification");
  const titleSpan = notif?.querySelector(".status");
  const messageEl = notif?.querySelector(".notification-status");

  if (failCount === 0) {
    // ✅ All success
    if (notif) {
      notif.classList.remove("error");
      notif.classList.add("active");
      if (titleSpan) titleSpan.textContent = "Successful";
      if (messageEl) messageEl.textContent = "Your preferences have been saved successfully.";
      setTimeout(() => notif.classList.remove("active"), 5000);
    }
  } else if (successCount > 0) {
    // ⚠️ Partial success
    if (notif) {
      notif.classList.remove("error");
      notif.classList.add("active");
      if (titleSpan) titleSpan.textContent = "Partial Success";
      if (messageEl) messageEl.textContent = `Some preferences were saved (${successCount}/${Object.keys(cleaned).length}).`;
      setTimeout(() => notif.classList.remove("active"), 5000);
    }
  } else {
    // ❌ All failed
    if (notif) {
      notif.classList.remove("active");
      notif.classList.add("error", "active");
      if (titleSpan) titleSpan.textContent = "Failed";
      if (messageEl) messageEl.textContent = "Failed to save preferences. Please try again.";
      setTimeout(() => notif.classList.remove("active", "error"), 5000);
    }
  }

  if (submitBtn) {
    submitBtn.disabled = false;
    submitBtn.textContent = originalText;
  }
});


});



// Master Add to Cart Form JS
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.add-to-cart-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault(); // Stop normal POST form

        const formData = new FormData(form);
        const id = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;

        CartJS.addItem(id, quantity, {}, {
          success: function (data, textStatus, jqXHR) {
            console.log('Added to cart:', data);
            // Optionally open your cart drawer
            document.getElementById('custom-cart-drawer')?.classList.add('open');
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.error('Add to cart error:', errorThrown);
          }
        });
      });
    });
  });

